import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom"; 
import "./Projects.css";
import { AsyncImage } from "loadable-image";
import FadeUp from "../FadeUp/FadeUp";
import projectsData from "../../data/projects.json";

const Projects = ({ isAlbanian }) => {
  const [projects, setProjects] = useState([]);
  const imagesLoaded = useRef(0);

  useEffect(() => {
    setProjects(projectsData);
  }, []);

  const handleImageLoad = () => {
    imagesLoaded.current += 1;
  };

  return (
    <div className="projectspage-container">
      <div className="overlay">
        <div className="vertical-line left"></div>
        <div className="vertical-line right"></div>
        <div className="projectspage-title">
          {isAlbanian ? "Projektet tona" : "Our Projects"}
        </div>
        <div className="bottom-line"></div>
      </div>

      <div className="projectspage-grid">
        {projects.map((project) => (
          <FadeUp key={project.project_id}>
            <Link
              className="projectspage-card"
              to={`/vilalproject/${project.project_id}`}
              onClick={(e) => {
                if (!e.ctrlKey && !e.metaKey) {
                  e.preventDefault();
                  window.location.href = `/vilalproject/${project.project_id}`;
                }
              }}
            >
              <div className="projectspage-image-square">
                <AsyncImage
                  src={project.project_image_url}
                  alt={project.project_title}
                  className="projectspage-image"
                  loading="lazy"
                  onLoad={handleImageLoad}
                />
              </div>
              <div className="projectspage-content">
                <h3 className="projectspagecard-title">
                  {isAlbanian ? project.titulli_projekti : project.project_title}
                </h3>
                <p className="projectspage-address">
                  {isAlbanian ? project.adresa_projekti : project.project_address}
                </p>
                <p className="projectspage-lookmore">
                  {isAlbanian ? "Shiko më shumë →" : "Look more →"}
                </p>
              </div>
            </Link>
          </FadeUp>
        ))}
      </div>
    </div>
  );
};

export default Projects;
